import { useState } from 'react';
import classNames from 'classnames/bind';

import { MochiCarousel, MochiLottie } from '@autopass-web/mochi-component';

import { REFUELING_TUTORIAL_VERTICAL_LIST_DATA } from '../../const';
import styles from './mochi-refueling-tutorial-carousel.module.sass';

const cx = classNames.bind(styles);

interface MochiRefuelingTutorialCarouselProps {
  isPlay?: boolean;
  refuelingServiceType: 'mochipay' | 'autopass' | 'barcode';
}

export const MochiRefuelingTutorialCarousel = ({
  isPlay = true,
  refuelingServiceType,
}: MochiRefuelingTutorialCarouselProps) => {
  const [index, setIndex] = useState<number>(0);
  const list = REFUELING_TUTORIAL_VERTICAL_LIST_DATA[refuelingServiceType];

  return (
    <MochiCarousel
      onSlideChange={(index) => setIndex(index)}
      items={list.map(({ lottie, content, id }, i) => (
        <div className={cx('item-container')} key={id}>
          <MochiLottie
            stopped={isPlay && i !== index}
            animationData={lottie}
            loop
          />
          <p className={cx('item-content')}>{content}</p>
        </div>
      ))}
    />
  );
};
